import React from 'react'
import * as S from './styles'
import { isMobile } from 'react-device-detect'
import { StrapiCompareClubs, StrapiPlan } from '@shared/utils/strapi/strapi.types'

type PlanSelectorProps = {
  compareClubs: StrapiCompareClubs,
  selectedPlan: StrapiPlan
  setSelectedPlan: ( plan: StrapiPlan ) => void,
}

const displayDiscountTag = ( discountTag: string ) => {
  if ( discountTag && discountTag !== '' ) {
    return (
      <S.DiscountBadge
        className="plan-selector-discount-badge"
      >
        {discountTag}
      </S.DiscountBadge>
    )
  }
  return null
}


const PlanSelector: React.FC<PlanSelectorProps> = ( props ) => {
  const { compareClubs, selectedPlan, setSelectedPlan } = props

  const content = (
    <S.Wrapper>
      {compareClubs.plans.map( ( plan ) => (
        <S.BadgeWrapper key={ plan.selectTitle }>
          {displayDiscountTag( plan.discountTag )}
          <S.Input
            type="radio"
            id={ plan.selectTitle }
            name="plan"
            value={ plan.selectTitle }
            checked={ selectedPlan.selectTitle === plan.selectTitle }
            onChange={ () => setSelectedPlan( plan ) }
          />
          <S.Label
            className="plan-selector-label"
            htmlFor={ plan.selectTitle }
            isSelected={ selectedPlan.selectTitle === plan.selectTitle }
          >
            {plan.selectTitle}
          </S.Label>
        </S.BadgeWrapper>
      ) )}
    </S.Wrapper>
  )

  return isMobile ? content : ( <S.DesktopWrapper> { content } </S.DesktopWrapper> )
}

export default PlanSelector
